/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as VideoDefs from './defs.defs.js'

const $nsid = 'app.bsky.video.finishUpload'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params()

export type $Params = l.InferOutput<typeof $params>

export const $input = /*#__PURE__*/ l.jsonPayload({
  jobId: /*#__PURE__*/ l.string({ minLength: 1, maxLength: 256 }),
})

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>

export const $output = /*#__PURE__*/ l.jsonPayload({
  completedJobId: /*#__PURE__*/ l.string({ minLength: 1, maxLength: 256 }),
  jobStatus: /*#__PURE__*/ l.ref<VideoDefs.JobStatus>(
    (() => VideoDefs.jobStatus) as any,
  ),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Finish an upload. This call is idempotent and safe to retry. On deduplication completedJobId may differ from the input jobId; poll getJobStatus with completedJobId. Probe-based validation failures surface later as JOB_STATE_FAILED from getJobStatus, not as errors from this call. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, [
  'UploadNotFound',
  'UploadExpired',
  'MissingParts',
  'UploadNotReady',
  'UnsupportedContentType',
  'UploadFailed',
  'UploadAborted',
  'ServiceOverloaded',
])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
